module.exports = __webpack_public_path__ + "files/38f3cfcb26970ecd1fb942c74681884a.png";